// src/services/authService.ts
import { SystemUser } from '@/models/SystemUser';
import { apiClient, tokenRefreshClient } from './api';


interface AdminLoginResponse {
  access_token: string;
  refresh_token: string;
  expires: string;
  token_type: string;
  admin_user: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_first_login: boolean;
  };
}

export const login = async (email: string, password: string): Promise<AdminLoginResponse> => {
  const response = await apiClient.post<AdminLoginResponse>('/admin/auth/token', {
    email,
    password
  });
  return response.data;
};

export const refreshToken = async (refreshToken: string): Promise<AdminLoginResponse> => {
  const response = await tokenRefreshClient.post<AdminLoginResponse>('/admin/auth/token/refresh', {
    refresh_token: refreshToken
  });
  return response.data;
};

// Fetch current admin user details
export const fetchAdminUserMe = async (): Promise<SystemUser> => {
  const response = await apiClient.get<SystemUser>('/admin/auth/me');
  return response.data;
};

export const requestPasswordReset = async (email: string): Promise<void> => {
  const response = await apiClient.post('/admin/auth/request-password-reset', { email });
  if (response.status !== 200) {
    throw new Error(response.data.message || 'Failed to request password reset');
  }
};

export const setPassword = async (token: string, password: string): Promise<{
  access_token: string;
  refresh_token: string;
  expires: string;
  token_type: string
}> => {
  const response = await apiClient.post('/admin/auth/set-password', { token, password });
  return response.data;
};